import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-invoice-without-header',
  templateUrl: './invoice-without-header.component.html',
  styleUrls: ['./invoice-without-header.component.css']
})
export class InvoiceWithoutHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
